export const WYExpiredApplicationsTeamsite = {
  heading: 'EXPIRED SHOPPERS',
  noResultsMessage: 'There are no expired shoppers to display.',
  sidebar: {
    headline: 'EXPIRED SHOPPERS',
    subText: 'Review information about customer application status.'
  },
  appSubmitSuccessMessage:
    "This record has been EXPIRED.<br><br>To restart the shopping process using previously entered customer data, select the ‘Activate' button, which will create a NEW CUSTOMER record, allowing you to shop for this customer again.",
  buttons: {
    editInfo: {
      display: true,
      text: 'EDIT INFO'
    },
    viewPlans: {
      display: true,
      text: 'VIEW PLANS'
    },
    planDetails: {
      display: true,
      text: 'PLAN DETAILS'
    },
    compare: {
      display: true,
      text: 'COMPARE'
    },
    edit: {
      display: true,
      text: 'EDIT'
    },
    shopPlans: {
      display: true,
      text: 'SHOP DIRECTLY WITH HIGHMARK'
    },
    goBackToFFM: {
      display: true,
      text: 'GO TO THE MARKETPLACE'
    },
    viewResults: {
      display: true,
      text: 'VIEW RESULTS'
    },
    editOnFFM: {
      display: true,
      text: 'GO TO THE MARKETPLACE'
    },
    initialPayment: {
      display: true,
      text: 'MAKE PAYMENT'
    },
    summary: {
      display: true,
      text: 'RETRIEVE'
    },
    moreInfo: {
      display: true,
      text: 'MORE INFO'
    }
  }
};
export const NDExpiredApplicationsTeamsite = {
  heading: 'EXPIRED SHOPPERS',
  noResultsMessage: 'There are no expired shoppers to display.',
  sidebar: {
    headline: 'EXPIRED SHOPPERS',
    subText:
      'Review information about customer application status from the Health Insurance Marketplace.'
  },
  appSubmitSuccessMessage:
    "This record has been set to EXPIRED.<br><br>To restart the shopping process using previously entered customer data, select the ‘Activate' button, which will create a NEW CUSTOMER record, allowing you to shop for this customer again.",
  buttons: {
    editInfo: {
      display: true,
      text: 'EDIT INFO'
    },
    viewPlans: {
      display: true,
      text: 'VIEW PLANS'
    },
    planDetails: {
      display: true,
      text: 'PLAN DETAILS'
    },
    compare: {
      display: true,
      text: 'COMPARE'
    },
    edit: {
      display: true,
      text: 'EDIT'
    },
    shopPlans: {
      display: true,
      text: 'SHOP DIRECTLY WITH BCBSND'
    },
    goBackToFFM: {
      display: true,
      text: 'GO TO THE MARKETPLACE'
    },
    viewResults: {
      display: true,
      text: 'VIEW RESULTS'
    },
    editOnFFM: {
      display: true,
      text: 'GO TO THE MARKETPLACE'
    },
    initialPayment: {
      display: true,
      text: 'MAKE PAYMENT'
    },
    summary: {
      display: true,
      text: 'RETRIEVE'
    },
    moreInfo: {
      display: true,
      text: 'MORE INFO'
    }
  }
};
